// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__38Pdj","title":"InfoRow_title__1kwU8"};